import { Skeleton, Link } from "@mui/material";
import rwandaLogo from "../assets/rwanda-logo.png";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getLetterCustomization } from "../../store/structure/actions";
import LetterSettings from "./LetterSettings";

const LetterTemplateHeader = (props) => {
  const {
    loading,
    entitySectorId,
    letterCustomization,
    getLetterCustomization,
    disableToEdit = false,
    loadHeaderContent,
    selectedPlanningEntityId,
    planningEntityId,
    onDownload,
  } = props;
  const [showEditHeaderDialog, setShowEditHeaderDialog] = useState(false);
  const [letterPosition, setLetterPosition] = useState("CenteredPosition");

  useEffect(() => {
    if (letterCustomization)
      setLetterPosition(
        letterCustomization?.letterPosition || "CenteredPosition"
      );
  }, [letterCustomization]);

  useEffect(() => {
    if (loadHeaderContent) loadHeaderContent(letterCustomization);
  }, [loadHeaderContent, letterCustomization]);

  useEffect(() => {
   // if ((!!selectedPlanningEntityId || !!planningEntityId) && !letterCustomization) {
      getLetterCustomization(
        entitySectorId,
        planningEntityId || selectedPlanningEntityId
      );
    //}
  }, [planningEntityId, selectedPlanningEntityId]);

  return (
    <>
      {loading ? (
        <>
          <Skeleton variant="rectangular" width={"100%"} height={80} />
        </>
      ) : (
        <>
          {!!letterCustomization &&
          !!letterCustomization.isHeaderLogoSettled ? (
            <>
              <div
                className={` my-3 d-flex justify-content-${
                  letterCustomization?.letterPosition === "LeftPosition"
                    ? "left"
                    : "center"
                } `}
              >
                <div
                  className="px-2"
                  style={{
                    minWidth: letterCustomization?.imgSize?.minWidth + "px",
                    maxWidth: letterCustomization?.imgSize?.maxWidth + "px",
                    minHeight: letterCustomization?.imgSize?.minHeight + "px",
                    maxHeight: letterCustomization?.imgSize?.maxHeight + "px",
                    boxSizing: "border-box",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "1px",
                    backgroundColor: "#ffff",
                  }}
                >
                  <img
                    src={
                      "data:image/png;base64," +
                      letterCustomization.letterHeaderLogo
                    }
                    style={{
                      width: "calc(100% - 5px)",
                      height: "calc(100% - 5px)",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
              <div
                style={{
                  backgroundColor: "#078ece",
                  height: `${letterCustomization?.styles?.headingBorderSize}px`,
                  border: `${letterCustomization?.styles?.headingBorderSize}px solid ${letterCustomization?.styles?.headingBorderColor}`,
                  borderRadius: "2px",
                }}
              ></div>

              {!disableToEdit && (
                <div className="w-100 text-center">
                  <button
                    className="btn btn-success text-uppercase btn-sm mt-2 px-4 mx-1"
                    onClick={() => {
                      setShowEditHeaderDialog(true);
                    }}
                  >
                    Customize
                  </button>
                  {!!onDownload && onDownload}
                </div>
              )}
            </>
          ) : (
            <>
              <div className="letterhead d-flex flex-column justify-content-center w-100 py-2">
                <div
                  className="letterhead-title w-100"
                  style={{ fontWeight: "bold" }}
                >
                  REPUBLIC OF RWANDA
                </div>
                <div className="w-100">
                  <img
                    style={{ width: "100px", height: "100px" }}
                    src={rwandaLogo}
                    alt="Logo"
                  />
                </div>
                <div className="letterhead-subtitle w-100">
                  <span
                    style={{ fontWeight: "bold", textTransform: "uppercase" }}
                  >
                    {(letterCustomization?.entity &&
                      letterCustomization?.entity?.name?.toUpperCase()) ||
                      ""}
                  </span>

                 
              {!disableToEdit && (
                <div className="w-100 text-center">
                  <button
                    className="btn btn-success text-uppercase btn-sm mt-2 px-4 mx-1"
                    onClick={() => {
                      setShowEditHeaderDialog(true);
                    }}
                  >
                    Customize
                  </button>
                  {!!onDownload && onDownload}
                </div>
              )}
                </div>
              </div>
            </>
          )}

          {showEditHeaderDialog && (
            <LetterSettings
              defaultTab={0}
              letterPosition={letterPosition}
              showEditHeaderDialog={showEditHeaderDialog}
              setShowEditHeaderDialog={setShowEditHeaderDialog}
              entitySectorId={entitySectorId}
            />
          )}
        </>
      )}
    </>
  );
};

const mapStateToProps = ({
  loading,
  onWait,
  letterCustomization,
  selectedPlanningEntityId,
}) => {
  return {
    loading,
    onWait,
    letterCustomization,
    selectedPlanningEntityId,
  };
};
export default connect(mapStateToProps, {
  getLetterCustomization,
})(LetterTemplateHeader);
